var React = require('react');

function ArrowUpwards (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0L1 5l1.414 1.414L5 3.83V12h2V3.829l2.586 2.585L11 5 6 0z","fill":"currentColor"}));
}

ArrowUpwards.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = ArrowUpwards;

ArrowUpwards.default = ArrowUpwards;
